"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCities_jericho = void 0;
var tslib_1 = require("tslib");
var index_1 = require("../../../Config/index");
var BaseApi_1 = tslib_1.__importDefault(require("../../../API/BaseApi"));
var index_2 = require("../index");
/**
 * @deprecated Use `searchCities` from the `oneGraph` package
 */
var getCities_jericho = function (request) {
    var response = BaseApi_1.default.doPostRequestToChegg(index_1.addressValidationUrl, request);
    return response
        .then(function (result) {
        return (0, index_2.addressValidationDataTransformer)(result);
    })
        .catch(function (error) { return JSON.parse(error.message); });
};
exports.getCities_jericho = getCities_jericho;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/addressValidationApi/jericho/index.js
// module id = 3376
// module chunks = 11